import "./styles.css";
import { Children, ElementType, ReactElement, ReactNode, useEffect, useState } from "react";
import { SectionProps, SectionUrlProps } from "../../../../contexts/CattleMapNavMenuContext";
import { ReactComponent as ChevronDown } from "../../../../assets/svg/icons/chevronDown.svg";
import { ReactComponent as ChevronRight } from "../../../../assets/svg/icons/chevronRight.svg";

type MenuContainerProps = {
  icon?: any;
  title?: string;
  children?: ReactNode | Array<ReactNode>;
  borderColor?: string;
  background?: string;
  isCollapsed?: boolean;
  onExpandSidebar?: () => void;
};

export function MenuContainer({ icon, title, children, borderColor, background, isCollapsed = false, onExpandSidebar }: MenuContainerProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldExpandOnSidebarOpen, setShouldExpandOnSidebarOpen] = useState(false);
  const Icon = icon as ElementType;
  
  // Isto armazena todas as urls passadas nos componentes filhos
  useEffect(() => {
    const listUrls: Array<SectionUrlProps> = Children.map(children as ReactElement, (child) => {
      const { name, title } = child.props;
      return { nameUrl: name, titleUrl: title };
    });
    const section = { title, icon: icon, urls: listUrls } as SectionProps;
  }, []);

  // Quando a sidebar expandir e o menu estava marcado para expandir, expandir o menu
  useEffect(() => {
    if (!isCollapsed && shouldExpandOnSidebarOpen) {
      setIsExpanded(true);
      setShouldExpandOnSidebarOpen(false);
    }
  }, [isCollapsed, shouldExpandOnSidebarOpen]);

  const handleToggle = () => {
    // Se estiver contraído, expandir a sidebar primeiro e marcar para expandir o menu depois
    if (isCollapsed && onExpandSidebar) {
      setShouldExpandOnSidebarOpen(true);
      onExpandSidebar();
      return;
    }
    setIsExpanded(!isExpanded);
  };

  return (
    <section
      className={`sidebar__card ${isCollapsed ? 'sidebar__card--collapsed' : ''}`}
      style={{ backgroundColor: background || "#FFFFFF", borderLeftColor: borderColor || "transparent" }}
    >
      {!isCollapsed && (
        <>
          <div className="sidebar__card--icon">{icon && <Icon />}</div>
          <div className="sidebar__card--right">
            <div className="sidebar__card--header" onClick={handleToggle}>
              <strong>{title}</strong>
              <div className="sidebar__card--toggle">
                {isExpanded ? <ChevronDown /> : <ChevronRight />}
              </div>
            </div>
            <div className={`sidebar__card--options ${isExpanded ? 'expanded' : 'collapsed'}`}>
              {children}
            </div>
          </div>
        </>
      )}
      {isCollapsed && (
        <div className="sidebar__card--collapsed-content" onClick={handleToggle} title={title}>
          {icon && <Icon />}
        </div>
      )}
    </section>
  );
}
